import { LpFooter } from '@livepolls/ui-components/src/components/footer/LpFooter';
import { TipType } from '@livepolls/ui-components/src/enums/tip-type.enum';
import { t } from 'i18next';
import React from 'react';
import { useState } from 'react';
import { useOptAuth } from 'src/contexts/auth.context';
import { useSubmitFeedBack } from 'src/hooks/store-hooks';
import { ISubmitFeedback } from 'src/models/submit-feedback.interface';

interface Props {
  licenseName: string | null;
}
export const FooterByAppType = ({ licenseName }: Props) => {
  const { user } = useOptAuth();
  const submitFeedBack = useSubmitFeedBack();
  const [error, setError] = useState<boolean>(false);

  const isZoomPage = window.location.pathname.startsWith('/zoom');
  if (isZoomPage) {
    return <span></span>;
  }

  const tips = [
    { type: TipType.LIFE_PRO_TIP, message: t('enterToAddOptions') },
    {
      type: TipType.LIFE_PRO_TIP,
      message: t('backspaceToDeleteAnOption'),
    },
    {
      type: TipType.YOU_SHOULD_KNOW,
      message: t('builtByThreeEngineers'),
    },
    {
      type: TipType.TODAY_I_LEARNED,
      message: t('qpInBusiness'),
    },
    {
      type: TipType.DO_YOU_KNOW,
      message: t('qpStarted'),
    },
    {
      type: TipType.TODAY_I_LEARNED,
      message: t('qpFirstCustomer'),
    },
  ];

  const submitResponse = async (response: ISubmitFeedback) => {
    try {
      await submitFeedBack.mutateAsync(response);
    } catch (err) {
      setError(true);
    }
  };

  const locations = [
    t('austin'),
    t('media'),
    t('pune'),
    t('berlin'),
    t('london'),
    t('dubai'),
  ];

  if (error) {
    return <div>Oops an error occurred</div>;
  }

  return (
    <LpFooter
      text={{
        locations,
        tips,
        with: t('with'),
        from: t('from'),
        poweredBy: t('poweredBy'),
        rateUs: t('rateUs'),
        cancel: t('cancel'),
        submit: t('submit'),
        feedback: t('feedback'),
        rating: t('rating'),
        wickUiVersion: t('wickUiVersion'),
        wickUiIconVersion: t('wickUiIconVersion'),
      }}
      submitFeedback={submitResponse}
      licenseName={licenseName}
      isAdmin={user?.isAdmin || false}
    />
  );
};
